import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API } from "@/lib/api";

// Per-tab session id (persists across navigation within tab)
function getSessionId() {
  let sid = sessionStorage.getItem("tmg_sid");
  if (!sid) {
    sid = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem("tmg_sid", sid);
  }
  return sid;
}

/**
 * Fire-and-forget event tracking. Never throws.
 * Uses sendBeacon when available so unload events still fire.
 */
export function trackEvent(type, opts = {}) {
  try {
    if (typeof window === "undefined") return;
    // Skip tracking on admin pages so internal usage doesn't pollute analytics
    if (window.location.pathname.startsWith("/admin")) return;

    const body = JSON.stringify({
      type,
      path: opts.path || window.location.pathname,
      session_id: getSessionId(),
      meta: opts.meta || {},
    });

    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(`${API}/event`, blob);
      return;
    }
    fetch(`${API}/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (_) {}
}

/** Hook: auto-tracks a pageview every time the route changes. */
export function usePageviewTracker() {
  const location = useLocation();
  useEffect(() => {
    trackEvent("pageview", { path: location.pathname + location.search });
  }, [location.pathname, location.search]);
}
